<div class="p-grid table-demo manage-product-section">
	<div class="p-col-12">
		<!-- <div class="p-col-12">
			<h5 class="head-page-title">User Detail</h5>
		</div> -->
		<div class="card">
			<p-toast key="toastmsg"></p-toast>

			<p-toolbar styleClass="p-mb-4">
				<ng-template pTemplate="left">
					<button pButton pRipple label="New" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2"
						(click)="addNewClub()"></button>
					<button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
						icon="pi pi-filter-slash" (click)="clear()
					"></button>
				</ng-template>
				<ng-template pTemplate="right">
					<button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
						class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
					<!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
				</ng-template>
			</p-toolbar>
			<!-- <div class="card">
				<div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-2"> 
						<label for="searchfield">Select Field</label>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field" optionLabel="label"></p-dropdown>
					</div>
					<div class="p-field p-col-3"> 
						<label for="startdt">Start Date</label>
						<p-calendar  monthNavigator="true" yearNavigator="true" yearRange="2022:2050"  [(ngModel)]="startDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" ></p-calendar>
					</div>
					<div class="p-field p-col-3"> 
						<label for="enddt">End Date</label>
						<p-calendar  monthNavigator="true" yearNavigator="true" yearRange="2022:2050"  [(ngModel)]="endDate" class="p-calendar" inputId="calendar"  dateFormat="dd/mm/yy" [showIcon]="true" ></p-calendar>
					</div>
					<div class="p-field p-col-3"> 						
						<button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2" (click)="loadUsers($event)"></button>
					</div>
				</div>
			</div> -->
			<p-table styleClass="p-datatable-customers p-datatable-gridlines p-datatable-striped" #dt [value]="clubList"
				[paginator]="true" [rows]="10" [lazy]="true" (onLazyLoad)="loadUsers($event)"
				[totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="paginationOption"
				paginatorPosition="bottom">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th pSortableColumn="name">
							<div class="p-d-flex p-jc-between p-ai-center">
								Name
								<p-sortIcon field="name"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="firstRanking">
							<div class="p-d-flex p-jc-between p-ai-center">
								First Ranking Name
								<p-sortIcon field="firstRanking"></p-sortIcon>
							</div>
						</th>
						<!-- <th pSortableColumn="gender">
							<div class="p-d-flex p-jc-between p-ai-center">
								Gender
								<p-sortIcon field="gender"></p-sortIcon>
							</div>
						</th> -->
						<th pSortableColumn="type">
							<div class="p-d-flex p-jc-between p-ai-center">
								Type
								<p-sortIcon field="type"></p-sortIcon>
							</div>
						</th>
						<!-- <th pSortableColumn="mobileNumber">
							<div class="p-d-flex p-jc-between p-ai-center">
								Mobile Number
								<p-sortIcon field="mobileNumber"></p-sortIcon>
							</div>
						</th> -->
						<!-- <th pSortableColumn="dob" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								DOB
								<p-sortIcon field="dob"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="weddingDate" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								Wedding Date
								<p-sortIcon field="weddingDate"></p-sortIcon>
							</div>
						</th> -->
						<th pSortableColumn="created_at" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								Created On
								<p-sortIcon field="created_at"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="updated_at" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								Modification Date
								<p-sortIcon field="updated_at"></p-sortIcon>
							</div>
						</th>
						<th pSortableColumn="status" class="col-width">
							<div class="p-d-flex p-jc-between p-ai-center">
								Status
								<p-sortIcon field="status"></p-sortIcon>
							</div>
						</th>
						<th>
							<div class="p-d-flex p-jc-between p-ai-center">
								Action
							</div>
						</th>
					</tr>
					<tr>
						<th [ngSwitch]="name">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
								style="width: 90px;" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
						</th>
						<th [ngSwitch]="firstRanking">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'firstRanking', 'contains')"
								style="width: 90px;"
								[value]="dt.filters['firstRanking'] ? dt.filters['firstRanking'].value : ''" />
						</th>
						<!-- <th [ngSwitch]="gender" class="col-width">
							<p-dropdown #pDropDownId [options]="genders" [style]="{'width':'80px'}" (onChange)="setDownloadFlag(); dt.filter($event.value, 'gender', 'equals')" styleClass="p-column-filter" placeholder="Select Gender" [showClear]="true">
								<ng-template let-option pTemplate="item" >
								<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
								</ng-template>
						</p-dropdown>
						</th> -->
						<th [ngSwitch]="type">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'type', 'contains')"
								style="width: 90px;" [value]="dt.filters['type'] ? dt.filters['type'].value : ''" />
						</th>
						<!-- <th [ngSwitch]="mobileNumber">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
								style="width: 90px;"
								[value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
						</th> -->
						<!-- <th [ngSwitch]="dob" class="col-width">
							<p-calendar #pCalendarId  class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy" (onSelect)="setDownloadFlag(); dt.filter($event,'dob', 'dateIs')" [showIcon]="true"  [(ngModel)]="dcalvalue" ></p-calendar>
						</th>
						<th [ngSwitch]="weddingDate" class="col-width">
							<p-calendar #pCalendarId  class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy" (onSelect)="setDownloadFlag(); dt.filter($event,'weddingDate', 'dateIs')" [showIcon]="true"  [(ngModel)]="wdcalvalue" ></p-calendar>
						</th> -->
						<th [ngSwitch]="created_at" class="col-width">
							<p-calendar #pCalendarId class="p-column-filter w-100" inputId="calendar"
								dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
								[showIcon]="true" [(ngModel)]="dcalvalue"></p-calendar>
						</th>
						<th [ngSwitch]="updated_at" class="col-width">
							<p-calendar #pCalendarId class="p-column-filter w-100" inputId="calendar"
								dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
								[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
						</th>
						<th [ngSwitch]="status" class="col-width">
							<p-dropdown #pDropDownId [options]="statuses"
								(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
								styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
								<ng-template let-option pTemplate="item">
									<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
								</ng-template>
							</p-dropdown>
						</th>
						<th>
							<!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-club>
					<tr class="p-selectable-row">
						<td>
							{{club.name}}
						</td>
						<td>
							{{club.firstRanking}}
						</td>
						<!-- <td>
							{{club.gender}}
						</td> -->
						<td>
							{{club.type}}
						</td>
						<!-- <td>
							{{club.mobileNumber}}
						</td> -->
						<!-- <td>
							{{club.dob | date:'d/M/yyyy'}}
						</td>-->
						<td>
							{{club.created_at | date:'d/M/yyyy'}}
						</td>
						<td>
							{{club.updated_at | date:'d/M/yyyy'}}
						</td>
						<td>
							<p-inputSwitch [(ngModel)]="club.status" (onChange)="changeStatus(club)"></p-inputSwitch>
						</td>
						<td>
							<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewUser(club.id)"></button> -->
							<button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-3"
								(click)="editClub(club.id)"></button>
							<!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
								(click)="deleteUser(club)"></button> -->
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Club not found.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						In total there are {{totalRecords }} Clubs.
					</div>
				</ng-template>
			</p-table>
		</div>
		<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
	</div>
</div>